import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    styleUrl: './imprint.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImprintComponent implements OnInit {
  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
